
export class MitWebsocket {
   static instance: null | MitWebsocket = null;
   static initiated = false;
   static subscriptions:{[key: string] : ((data: ServerMessages) => void)[]} = {};
   static validated = false;
   static queue: any[] = [];
   websocket: null | WebSocket = null;

   static getInitiated(): MitWebsocket | undefined {
      if (MitWebsocket.initiated) {
         return MitWebsocket.getInstance()
      }
      return undefined;
   }
   
   static closeInstance() {
      if (MitWebsocket.instance) {
         MitWebsocket.instance?.websocket?.close?.();
         MitWebsocket.instance = null;
         MitWebsocket.initiated = false;
      }
   }
   
   static getInstance() {
      if (MitWebsocket.instance == null) {
         MitWebsocket.instance = new MitWebsocket();
         MitWebsocket.initiated = true;
      }
      return MitWebsocket.instance;
   }

   static subscribe(channel:string, callback: (data: ServerMessages) => void) { 
      if (!(channel in MitWebsocket.subscriptions)) {
         MitWebsocket.send({ type: "joinChannel", action: { channel } });
         MitWebsocket.subscriptions[channel] = [];
      }
      MitWebsocket.subscriptions[channel].push(callback);
   }

   static unsubscribe(channel: string, callback: (data: ServerMessages) => void) {
      MitWebsocket.subscriptions[channel] = MitWebsocket.subscriptions[channel].filter((cb) => cb !== callback);
      if (MitWebsocket.subscriptions[channel].length === 0) {
         MitWebsocket.send({ type: "leaveChannel", action: { channel } });
         delete MitWebsocket.subscriptions[channel];
      }
   }

   static callSubscriptions(channel: string, data: ServerMessages) {
      if (channel in MitWebsocket.subscriptions) {
         MitWebsocket.subscriptions[channel].forEach((cb: any) => cb(data));
      }
   }

   static rejoinSubscribtions() {
      Object.keys(MitWebsocket.subscriptions).forEach((channel) => {
         if (MitWebsocket.subscriptions[channel].length > 0) {
            MitWebsocket.send({ type: "joinChannel", action: { channel } });
         }
      });
   }
   
   constructor() {
      const onmessage = (event) => {
        try {
            const data = JSON.parse(event.data) as ServerMessages;
            // Handle channel messages
            if (data.action.channel && MitWebsocket.subscriptions[data.action.channel]) {
               MitWebsocket.subscriptions[data.action.channel].forEach((cb) => cb(data));
            }
         } catch {
            // Handle nonJson Messages
            if (nonJsonMessages.includes(event.data)) {
               handleNonJsonMessages(event.data, this.websocket!);
               return;
            }
         }
      }
      this.websocket = null;
      try {
         this.websocket = new WebSocket('wss://ws.viamap.net');
         this.websocket.onopen = () => {
            this.websocket?.send(JSON.stringify({ type: "accessWebsocket", action: { user: "<user_id>" } }));
            MitWebsocket.rejoinSubscribtions();
         };
         this.websocket.onmessage = onmessage;
         this.websocket.onclose = (ev) => {
            MitWebsocket.closeInstance();
            console.log("Websocket closed", ev);
         if (!ev.wasClean) {
            setTimeout(() => {
               return MitWebsocket.getInstance()
            }, 5000);
         }
         // MitWebsocket.closeInstance();
         }
         return this
      } catch {
         setTimeout(() => {
            return MitWebsocket.getInstance();
         }, 5000);
      }
   }
   
   static send(data: any) {
      let x = MitWebsocket.getInitiated()
      try {
         if (x && x.websocket?.readyState == 1) {
            if (MitWebsocket.queue) {
               while (MitWebsocket.queue.length > 0) {
                  let qData = MitWebsocket.queue.pop()
                  x.websocket?.send(JSON.stringify(qData));
               }
            }
            x.websocket?.send(JSON.stringify(data));
         }
      } catch (err) {
         console.error("WebSocket send error:", err);
         MitWebsocket.queue.push(data);
      }
   }
}

export type WebSocketClientActions = {
   "joinChannel": { type: "joinChannel"; action: { channel: string } };
   "leaveChannel": { type: "leaveChannel"; action: { channel: string } };
   "updateChannel": { type: "updateChannel"; action: { channel: string } };
   "sendToChannel": { type: "sendToChannel"; action: { channel: string; data: any } };

   "accessWebsocket" : { type: "accessWebsocket"; action: { user: string } };

   "received": { type: "received"; id?: string | number };
}

export type WebSocketServerActions = {
   "members": { type: "members"; action: { channel: string; members: string[] } };
   "data": { type: "data"; action: { channel: string; data: any } };
   "update": { type: "update"; action: { channel: string;  } };
   "message": { type: "message"; action: { channel:string, message: string } };
}

export type ServerMessages = WebSocketServerActions[keyof WebSocketServerActions]

export type ClientActionReturn = {
   "received": { type: "received"; id?: string | number };
}

// Non-JSON Messages
const nonJsonMessages = ["ping", "pong"] as const;
/**
 * Handle messages that are not valid JSON
 * Uses for special cases and heartbeats (keep-alive)
 */
function handleNonJsonMessages(type: typeof nonJsonMessages[number] | string, socket: WebSocket) {
   switch (type) {
      case "ping":
         socket.send("pong");
         break;
      case "pong":
         socket.send("ping");
         break;
      default:
         // Messages not handled
         // Fail silently
         break;
   }
};